// extracted by mini-css-extract-plugin
export default {"CentrePattern":"index_CentrePattern__21GYb"};